import { render, staticRenderFns } from "./FortalSeg.vue?vue&type=template&id=3f6cbc3f&scoped=true"
import script from "./FortalSeg.vue?vue&type=script&lang=js"
export * from "./FortalSeg.vue?vue&type=script&lang=js"
import style0 from "./FortalSeg.vue?vue&type=style&index=0&id=3f6cbc3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6cbc3f",
  null
  
)

export default component.exports